<template>
  <FiltersItem>
    <template #title>
      {{ $l('global.simplePhrases.airports') }}
    </template>
    <template #content>
      <!-- Departure Airports -->
      <FiltersItemContent>
        <template #title>
          {{ $l('global.simplePhrases.departureAirports') }}
        </template>
        <template #content>
          <FiltersList
            :items="uniqueDepartures"
            @itemClicked="filtersStore.toggleValue('airportDepartures', $event.value)"
            @exclusiveClicked="onExclusiveClickDepartures"
          />
        </template>
      </FiltersItemContent>
      <!-- Arrival stations -->
      <FiltersItemContent>
        <template #title>
          {{ $l('global.simplePhrases.arrivalAirports') }}
        </template>
        <template #content>
          <FiltersList
            :items="uniqueArrivals"
            @itemClicked="filtersStore.toggleValue('airportArrivals', $event.value)"
            @exclusiveClicked="onExclusiveClickArrivals"
          />
        </template>
      </FiltersItemContent>
      <!-- Transfer stations -->
      <FiltersItemAirportsTransfers />
    </template>
    <template #summary>
      <FiltersItemSummary :items="summaryItems" />
    </template>
  </FiltersItem>
</template>

<script setup>
import { arrayToggleValue, lreplace } from '@js/utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();

const uniqueAirportMap = (item, filterStoreKey) => {
	return {
		text: resultQueryStore.state.response.airportDetails[item.iata].airport,
		value: item.iata,
		isChecked: filtersStore.state?.[filterStoreKey].length === 0 || !filtersStore.state?.[filterStoreKey]?.includes(item.iata)
	};
};

const summaryItems = computed(() => {
	return [
		{ filterKey: 'airportDepartures', data: uniqueDepartures.value, prefixText: 'showresult.filter.summary.excludeAirportLeave' },
		{ filterKey: 'airportArrivals', data: uniqueArrivals.value, prefixText: 'showresult.filter.summary.excludeAirportLeave' },
		{ filterKey: 'airportStops', data: uniqueAirportStops.value, prefixText: 'showresult.filter.summary.excludeAirportTransfer' }
	]
		.map((item) => {
			const { filterKey, data, prefixText } = item;
			// If the filter has been set
			if (!filtersStore.state?.[filterKey]?.length || !data?.length) {
				return false;
			}
			// Map each filter item into it's text value
			const selectedItems = filtersStore.state[filterKey].map(filterItem => data.find(dataItem => filterItem === dataItem.value).text);
			return lreplace(prefixText, { airports: selectedItems.join(', ') });
		})
		.filter(Boolean);
});

const uniqueAirportStops = computed(() => resultQueryStore.state?.response?.uniqueAirportStops?.map?.(item => uniqueAirportMap(item, 'airportStops')));
const uniqueDepartures = computed(() => resultQueryStore.state?.response?.uniqueAirportDepartures?.map?.(item => uniqueAirportMap(item, 'airportDepartures')) || []);
const uniqueArrivals = computed(() => resultQueryStore.state.response?.uniqueAirportArrivals?.map?.(item => uniqueAirportMap(item, 'airportArrivals')) || []);

function onExclusiveClickDepartures (item) {
	const newFilter = arrayToggleValue(uniqueDepartures.value.map(item => item.value), item.value);
	filtersStore.set({ key: 'airportDepartures', value: newFilter });
}

function onExclusiveClickArrivals (item) {
	const newFilter = arrayToggleValue(uniqueArrivals.value.map(item => item.value), item.value);
	filtersStore.set({ key: 'airportArrivals', value: newFilter });
}
</script>
